import { Button as MUIButton, lighten, darken } from '@mui/material'

import withStyles from '@mui/styles/withStyles'

const ButtonTertiary = withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid rgb(255, 99, 71)',
    borderRadius: '8px',
    width: '124px',
    height: '36px',
    background: 'rgb(255, 99, 71)',
    color: 'white',

    '&:hover': {
      background: darken('rgb(255, 99, 71)', 0.2)
    },

    '&:disabled': {
      color: `${lighten('rgb(255, 99, 71)', 0.6)} !important`,
      opacity: '0.5'
    }
  },

  text: {
    fontSize: theme.size.base,
    textTransform: 'none'
  }
}))(MUIButton)

export default ButtonTertiary
